export default __webpack_public_path__ + "static/media/Q3-1.a6d8b830.png";